import $ from 'jquery';
window.$ = window.jQuery = $;
import { default as Common } from './modules/common.js';
import { default as Tabs } from './modules/tabs.js';
import { default as Modals } from './modules/modals.js';
import { default as Video } from './modules/video.js';
import { default as Filters } from './modules/filters.js';
import { default as Insights } from './modules/insights.js';
import { default as Search } from './modules/search.js';
import { default as initFreeformValidation } from './modules/freeform-validation.js';

const modules = {
  Common,
  Tabs,
  Video,
  Modals,
  Filters,
  Insights,
  Search
};

// Make Freeform validation available globally for Twig templates
window.initFreeformValidation = initFreeformValidation;

Object.keys(modules).forEach(key => {
  modules[key].init();
  window[key] = modules[key];
});
